import type { Form } from '../../../../common/types/form';
import type { Document } from '../../../../common/types/client';

const documentForm: Form<Document> = {
  key: 'documents',
  title: 'Dokumente',
  fields: [
    {
      key: 'name',
      label: 'Dokumentname',
      fieldTypes: 'text',
      xsWidth: 6,
    },
    {
      key: 'link',
      label: 'Link',
      fieldTypes: 'inputLink',
      xsWidth: 6,
    },
  ],
};

export default documentForm;
